/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function EphemeralEnvironmentIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="M33 30v-4c0-.5-.5-1-1-1H8c-.562 0-1 .5-1 1v4c0 .563.438 1 1 1h24c.5 0 1-.437 1-1m-1 4H8c-2.25 0-4-1.75-4-4v-4c0-2.187 1.75-4 4-4h24c2.188 0 4 1.813 4 4v4c0 2.25-1.812 4-4 4M22 14c0 2.25-1.812 4-4 4H8c-2.25 0-4-1.75-4-4v-4c0-2.187 1.75-4 4-4h19c2.438 0 4.5 2.063 4.5 4.5v2.438l1.438-1.438a1.37 1.37 0 0 1 2.062 0c.625.563.625 1.5 0 2.063l-4 4c-.562.625-1.5.625-2.062 0l-4-4a1.37 1.37 0 0 1 0-2.063 1.37 1.37 0 0 1 2.062 0l1.438 1.438V10.5c0-.812-.625-1.5-1.5-1.5h-5.125c.125.375.125.688.125 1v4z"/>}
        </IconWrapper>);
}
